import { Button, Col, Form, Input, message, Row, Spin, Table } from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import API from "../../../services/api-request";
import { capitalizeLetter } from "../../../utils/capitalizeLetter";

const DetailRequestInbound = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [editForm] = Form.useForm();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const getDataDetail = (id) => {
    setLoading(true);
    API.Get(`transaction/inbound/detail/${id}`)
      .then((result) => {
        setLoading(false);

        const transformedItem = {
          ...result?.data,
          status: capitalizeLetter(result?.data?.status),
          request_at: dayjs(result?.data?.request_at).format("YYYY-MM-DD"),
          schedule_at: dayjs(result?.data?.schedule_at).format("YYYY-MM-DD"),
        };

        editForm.setFieldsValue(transformedItem);

        setData(transformedItem);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        message.info("Failed Fetch Request Inbound Detail");
      });
  };

  useEffect(() => {
    console.log(id);
    if (id) {
      getDataDetail(id);
    }
  }, [id]);

  const onFinish = async (values) => {};

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const columnsProducts = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      width: 60,
      render: (no) => no,
    },
    {
      title: "Jenis Produk",
      dataIndex: "product",
      key: "product",
      sorter: (a, b) => a.product?.name - b.product?.name,
      render: (product) => {
        if (product?.name === null || product?.name === "") {
          return "-";
        } else {
          return product?.name;
        }
      },
    },
    {
      title: "Estimasi Berat",
      dataIndex: "estimate_weight",
      key: "estimate_weight",
      sorter: (a, b) => a.estimate_weight - b.estimate_weight,
      render: (estimate_weight) => {
        if (estimate_weight === null || estimate_weight === "") {
          return "-";
        } else {
          return `${estimate_weight.toLocaleString("id-ID", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          })} Kg`;
        }
      },
    },
    {
      title: "Jumlah Pack",
      dataIndex: "estimate_qty",
      key: "estimate_qty",
      sorter: (a, b) => a.estimate_qty - b.estimate_qty,
      render: (estimate_qty) => {
        if (estimate_qty === null || estimate_qty === "") {
          return "-";
        } else {
          return estimate_qty;
        }
      },
    },
    {
      title: "Spesifikasi",
      dataIndex: "estimate_specification",
      key: "estimate_specification",
      sorter: (a, b) => a.estimate_specification - b.estimate_specification,
      render: (estimate_specification) => {
        if (estimate_specification === null || estimate_specification === "") {
          return "-";
        } else {
          return estimate_specification;
        }
      },
    },
  ];

  console.log(data.transaction_details);

  const columnsDetailpallets = [
    {
      title: "Pallet",
      dataIndex: "pallet",
      key: "pallet",
      sorter: (a, b) => a.pallet?.name - b.pallet?.name,
      render: (pallet) => {
        if (pallet === null || pallet === "") {
          return "-";
        } else {
          return pallet?.name;
        }
      },
    },
    {
      title: "Tally",
      dataIndex: "tally",
      key: "tally",
      sorter: (a, b) => a.tally?.name - b.tally?.name,
      render: (tally) => {
        if (!tally) {
          return "-";
        } else {
          return tally?.name;
        }
      },
    },
    {
      title: "Operator",
      dataIndex: "operator",
      key: "operator",
      sorter: (a, b) => a.operator?.name - b.operator?.name,
      render: (operator) => {
        if (operator === null || operator === "") {
          return "-";
        } else {
          return operator?.name;
        }
      },
    },
    {
      title: "Berat",
      dataIndex: "weight",
      key: "weight",
      sorter: (a, b) => a.weight - b.weight,
      render: (weight) => {
        if (weight === null || weight === "") {
          return "-";
        } else {
          return `${weight.toLocaleString("id-ID", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          })} Kg`;
        }
      },
    },
    {
      title: "Spesifikasi",
      dataIndex: "specification",
      key: "specification",
      sorter: (a, b) => a.specification - b.specification,
      render: (specification) => {
        if (specification === null || specification === "") {
          return "-";
        } else {
          return specification;
        }
      },
    },
    {
      title: "Jumlah Pack",
      dataIndex: "qty",
      key: "qty",
      sorter: (a, b) => a.qty - b.qty,
      render: (qty) => {
        if (qty === null || qty === "") {
          return "-";
        } else {
          return qty;
        }
      },
    },
    {
      title: "Cold Storage",
      dataIndex: "area",
      key: "area",
      sorter: (a, b) => a.area?.warehouse?.n - b.area?.warehouse?.n,
      render: (area) => {
        if (area === null || area === "") {
          return "-";
        } else {
          return area?.warehouse?.n;
        }
      },
    },
    // {
    //   title: "Area",
    //   dataIndex: "area",
    //   key: "area",
    //   sorter: (a, b) => a.area?.name - b.area?.name,
    //   render: (area) => {
    //     if (area === null || area === "") {
    //       return "-";
    //     } else {
    //       return area?.name;
    //     }
    //   },
    // },
  ];

  return (
    <>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <Form
          form={editForm}
          name="Edit Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          autoComplete="off"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Row gutter={[8, 8]}>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Status"
                name="status"
                rules={[
                  {
                    required: true,
                    message: "Please input your Status!",
                  },
                ]}
              >
                <Input placeholder="Status" readOnly />
              </Form.Item>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}></Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Tanggal Request"
                name="request_at"
                rules={[
                  {
                    required: true,
                    message: "Please input your Tanggal Request!",
                  },
                ]}
              >
                <Input placeholder="Tanggal Request" readOnly />
              </Form.Item>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Tanggal Masuk"
                name="schedule_at"
                rules={[
                  {
                    required: true,
                    message: "Please input your Tanggal Masuk!",
                  },
                ]}
              >
                <Input placeholder="Tanggal Masuk" readOnly />
              </Form.Item>
            </Col>
            <Col lg={24} md={24} sm={24} xs={24}>
              <div style={{ fontWeight: 600, marginBottom: 10 }}>
                Jenis Produk & Estimasi Berat/Jumlah Pack
              </div>
            </Col>
            <Col lg={24} md={24} sm={24} xs={24}>
              <Table
                dataSource={data.transaction_details}
                columns={columnsProducts}
                rowKey={(dataSource) => dataSource.id}
                expandable={{
                  expandedRowRender: (record) => (
                    <Table
                      columns={columnsDetailpallets}
                      dataSource={record.transaction_detail_pallets}
                      rowKey={(dataSource) => dataSource.id}
                      pagination={false}
                    />
                  ),
                }}
                summary={(pageData) => {
                  const totalEstimateWeight = pageData.reduce(
                    (sum, item) => sum + (item.estimate_weight || 0),
                    0
                  );

                  const totalEstimateQty = pageData.reduce(
                    (sum, item) => sum + (item.estimate_qty || 0),
                    0
                  );

                  return (
                    <Table.Summary.Row>
                      <Table.Summary.Cell>
                        <span style={{ fontWeight: "bold" }}>Total</span>
                      </Table.Summary.Cell>
                      {columnsProducts.map((column, index) => {
                        if (column.dataIndex === "estimate_weight") {
                          return (
                            <Table.Summary.Cell key={column.key} index={index}>
                              <span style={{ fontWeight: "bold" }}>
                                {totalEstimateWeight?.toLocaleString("id-ID", {
                                  minimumFractionDigits: 1,
                                  maximumFractionDigits: 1,
                                })}{" "}
                                kg
                              </span>
                            </Table.Summary.Cell>
                          );
                        }

                        if (column.dataIndex === "estimate_qty") {
                          return (
                            <Table.Summary.Cell key={column.key} index={index}>
                              <span style={{ fontWeight: "bold" }}>
                                {totalEstimateQty}
                              </span>
                            </Table.Summary.Cell>
                          );
                        }

                        return (
                          <Table.Summary.Cell key={column.key} index={index} />
                        );
                      })}
                    </Table.Summary.Row>
                  );
                }}
                pagination={false}
              />
            </Col>
            {/* <Col lg={24} md={24} sm={24} xs={24}>
              <Form.Item label="Keterangan" name="reason">
                <TextArea
                  placeholder="Keterangan"
                  autoSize={{
                    minRows: 2,
                    maxRows: 6,
                  }}
                />
              </Form.Item>
            </Col> */}
            <Col lg={24} md={24} sm={24} xs={24}>
              <Button
                style={{
                  width: "100%",
                  backgroundColor: "orange",
                  borderColor: "orange",
                  color: "white",
                }}
                type="primary"
                onClick={() => handleBack()}
              >
                Kembali
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </>
  );
};

const buttonStyle = {
  width: "100%",
};

export default DetailRequestInbound;
